import {
  FETCH_ESTIMATE,
  FETCH_ESTIMATE_SUCCESS,
  FETCH_ESTIMATE_FAILED,
  CLEAR_ESTIMATE
} from "../store/types";
import Polyline from '@mapbox/polyline';
import { firebase } from '../config/configureFirebase';
import { FareCalculator } from '../other/FareCalculator';

const inferPaxFromCar = (carDetails) => {
  if (!carDetails) return 1;
  const candidates = [
    carDetails.maxPersons,
    carDetails.max_persons,
    carDetails.maxPassengers,
    carDetails.passengers,
    carDetails.persons,
    carDetails.person,
    carDetails.capacity,
    carDetails.seats,
    carDetails.seatingCapacity
  ].filter(v => typeof v === 'number');
  if (candidates.length) {
    const max = Math.max(...candidates);
    if (!isNaN(max) && max > 0) return max;
  }
  if (carDetails.extra_info && typeof carDetails.extra_info === 'string') {
    const nums = carDetails.extra_info.match(/\d+/g);
    if (nums && nums.length) {
      const max = Math.max(...nums.map(n => parseInt(n)));
      if (!isNaN(max) && max > 0) return max;
    }
  }
  return 1;
};

export const getEstimate = (bookingData) => async (dispatch) => {
  const   {
      settingsRef
  } = firebase;

  dispatch({
    type: FETCH_ESTIMATE,
    payload: bookingData,
  });
          

  let res = bookingData.routeDetails;

  if(res){
    let points = Polyline.decode(res.polylinePoints);

    let waypoints = points.map((point) => {
        return {
            latitude: point[0],
            longitude: point[1]
        }
    });
    
    settingsRef.once("value", async settingdata => {
      let settings = settingdata.val();
      let distance = settings.convert_to_mile? (res.distance_in_km / 1.609344) : res.distance_in_km;

     let breakdown = null;
     let currency = settings.symbol || 'NOK';

     // Try backend fare calculation
     try {
       const host = `https://us-central1-${firebase.config.projectId}.cloudfunctions.net`;
       const body = {
         distance_km: res.distance_in_km,
         duration_min: res.time_in_secs / 60,
         pax: inferPaxFromCar(bookingData.carDetails),
         datetime_iso: new Date().toISOString(),
         wheelchair: bookingData?.instructionData?.wheelchair || false
       };
       const resp = await fetch(`${host}/calculate_fare`, {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify(body)
       });
       if(resp.ok){
         const json = await resp.json();
         if(json && json.breakdown){
           breakdown = json.breakdown;
           currency = json.currency || currency;
           if (json.rates) {
             breakdown.rates = json.rates;
           }
         }
       }
     } catch(e){
       // Fallback handled below
     }

     let totalCost = null, grandTotal = null, convenience_fees = null;
     if (breakdown) {
        totalCost = breakdown.total;
        grandTotal = breakdown.total;
        convenience_fees = 0;
     } else {
        // Fallback to legacy FareCalculator
        const resCalc = FareCalculator(distance, res.time_in_secs, bookingData.carDetails, bookingData.instructionData, settings.decimal);
        totalCost = resCalc.totalCost;
        grandTotal = resCalc.grandTotal;
        convenience_fees = resCalc.convenience_fees;
     }
     
      dispatch({
        type: FETCH_ESTIMATE_SUCCESS,
        payload: {
          pickup:bookingData.pickup,
          drop:bookingData.drop,
          carDetails:bookingData.carDetails,
          instructionData: bookingData.instructionData,
          estimateDistance: parseFloat(distance).toFixed(settings.decimal),
          fareCost: totalCost ? parseFloat(totalCost).toFixed(settings.decimal) : 0,
          estimateFare: grandTotal ? parseFloat(grandTotal).toFixed(settings.decimal) : 0,
          estimateTime:res.time_in_secs,
          convenience_fees: convenience_fees ? parseFloat(convenience_fees).toFixed(settings.decimal) : 0,
          waypoints: waypoints,
          breakdown,
          currency
        },
      });
    });
  }else{
    dispatch({
      type: FETCH_ESTIMATE_FAILED,
      payload: "No Route Found",
    });
  }

}

export const clearEstimate = () => (dispatch) => {
    dispatch({
        type: CLEAR_ESTIMATE,
        payload: null,
    });    
}
